/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAaa_pricefactorgridViewProps } from './aaa_pricefactorgrid';
import { Button } from '@msdyn365-commerce-modules/utilities';

export default (props: IAaa_pricefactorgridViewProps) => {
    return props.priceFactors.length > 0 ? (
        <>
            <table className='manage-price__table'>
                <thead className='manage-price__table__thead'>
                    <tr className='manage-price__table__thead__tr'>
                        <th style={{ width: '20%', textAlign: 'left' }}>Description</th>
                        <th style={{ width: '10%', textAlign: 'center' }}>Markup</th>
                    </tr>
                </thead>
                <tbody className='manage-price__table__tbody'>
                    {props.priceFactors.map((row: any, index: number) => {
                        return (
                            <tr key={index} className='manage-price__table__tbody__tr'>
                                <td style={{ textAlign: 'left' }}>{props.priceFactors[index].BMAPriceFactorDescription}</td>
                                <td style={{ textAlign: 'center' }}>
                                    {props.editMode ? (
                                        <input
                                            style={{ width: '4em' }}
                                            onChange={e => props.handleChange(index, 'BMAPriceFactorPercent', e.target.value)}
                                            type='number'
                                            step='1'
                                            min='0'
                                            className='form-control'
                                            value={props.priceFactors[index].BMAPriceFactorPercent}
                                        />
                                    ) : (
                                        props.priceFactors[index].BMAPriceFactorPercent
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>

                <tfoot className='manage-price__table__tfoot'>
                    <tr className='manage-price__table__tfoot__tr'>
                        <th style={{ width: '20%' }}></th>
                        <th style={{ width: '10%' }}>
                            {props.editMode ? (
                                <>
                                    {' '}
                                    <Button
                                        className='manage-price__table__tfoot__tr__th__button'
                                        title={'Update Price Factor'}
                                        onClick={() => props.updatePriceFactor()}
                                    >
                                        {'Save'}
                                    </Button>{' '}
                                    <span>&#47;</span>
                                    <Button
                                        className='manage-price__table__tfoot__tr__th__button'
                                        title={'Cancel'}
                                        onClick={() => props.toggleEditMode()}
                                    >
                                        {'Cancel'}
                                    </Button>
                                </>
                            ) : (
                                <Button
                                    className='manage-price__table__tfoot__tr__th__button'
                                    title={'Edit'}
                                    onClick={() => props.toggleEditMode()}
                                >
                                    {'Edit'}
                                </Button>
                            )}
                        </th>
                    </tr>
                </tfoot>
            </table>
        </>
    ) : (
        <h3 style={{ textAlign: 'center' }}>{!props.isPriceFactorAvailable && props.isPriceFactorsNotAvailableText}</h3>
    );
};
